import * as action_types from "./constants";

export type myCompanyState = {
  clientListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
};

const initialState: myCompanyState = {
  clientListData: {
    loader: true,
    data: null,
    count: 0,
  },
};

type MyCompanyActionType = {
  type: typeof action_types.UPDATE_COMPANY_SETTINGS;
  data: { payload: []; loading: boolean; count: number };
};

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.UPDATE_COMPANY_SETTINGS:
      return {
        ...state,
        clientListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
